import { Feature } from '@tencent/workbench';
import BaseDrawerFeature from '@framework/workbench/common/feature/base-drawer-feature';

@Feature()
export class SlideSizeFeature extends BaseDrawerFeature {
    public getSlideSizeType(): string {
        return this.getUiDataService().presentation?.props?.slideSizeType?.toString();
    }
}
